import type { Category, Product, ShopSettings, Subcategory } from "../../shared/types";

async function request<T>(url: string): Promise<T> {
  const response = await fetch(url, { headers: { accept: "application/json" }, cache: "no-store" });
  if (!response.ok) throw new Error("request_failed");
  return response.json() as Promise<T>;
}

export const api = {
  products: () => request<{ products: Product[] }>("/api/products"),
  product: (id: string) => request<{ product: Product }>(`/api/products/${encodeURIComponent(id)}`),
  categories: () => request<{ categories: Category[] }>("/api/categories"),
  subcategories: () => request<{ subcategories: Subcategory[] }>("/api/subcategories"),
  settings: () => request<{ settings: ShopSettings }>("/api/settings"),
};

export const imageUrl = (product: Product) => `/api/images/${encodeURIComponent(product.image_key)}?v=${product.image_version}`;
